/* global debounce */

(() => {

const rpgSearchSystems = [
  { title: 'Nintendo', handle: 'nintendo', family: 'nintendo', aliases: ['nintendo'] },
  { title: 'NES', handle: 'nes', family: 'nintendo', aliases: ['nes', 'nintendo entertainment system'] },
  { title: 'Super Nintendo', handle: 'super-nintendo', family: 'nintendo', aliases: ['snes', 'super nintendo'] },
  { title: 'Nintendo 64', handle: 'nintendo-64', family: 'nintendo', aliases: ['n64', 'nintendo 64'] },
  { title: 'GameCube', handle: 'gamecube', family: 'nintendo', aliases: ['gamecube', 'game cube'] },
  { title: 'Wii', handle: 'wii', family: 'nintendo', aliases: ['wii'] },
  { title: 'Wii U', handle: 'wii-u', family: 'nintendo', aliases: ['wii u', 'wiiu'] },
  { title: 'Game Boy', handle: 'game-boy', family: 'nintendo', aliases: ['game boy', 'gameboy'] },
  { title: 'Game Boy Color', handle: 'game-boy-color', family: 'nintendo', aliases: ['game boy color', 'gameboy color', 'gbc'] },
  { title: 'Game Boy Advance', handle: 'game-boy-advance', family: 'nintendo', aliases: ['game boy advance', 'gameboy advance', 'gba'] },
  { title: 'Nintendo DS', handle: 'nintendo-ds', family: 'nintendo', aliases: ['nintendo ds', 'ds'] },
  { title: 'Nintendo 3DS', handle: 'nintendo-3ds', family: 'nintendo', aliases: ['nintendo 3ds', '3ds'] },
  { title: 'Nintendo Switch', handle: 'nintendo-switch', family: 'nintendo', aliases: ['nintendo switch', 'switch'] },
  { title: 'Nintendo Switch 2', handle: 'nintendo-switch-2', family: 'nintendo', aliases: ['nintendo switch 2', 'switch 2'] },
  { title: 'PlayStation', handle: 'playstation', family: 'playstation', aliases: ['playstation', 'sony'] },
  { title: 'PlayStation 1', handle: 'playstation-1', family: 'playstation', aliases: ['playstation 1', 'ps1', 'ps one'] },
  { title: 'PlayStation 2', handle: 'playstation-2', family: 'playstation', aliases: ['playstation 2', 'ps2'] },
  { title: 'PlayStation 3', handle: 'playstation-3', family: 'playstation', aliases: ['playstation 3', 'ps3'] },
  { title: 'PlayStation 4', handle: 'playstation-4', family: 'playstation', aliases: ['playstation 4', 'ps4'] },
  { title: 'PlayStation 5', handle: 'playstation-5', family: 'playstation', aliases: ['playstation 5', 'ps5'] },
  { title: 'PSP', handle: 'psp', family: 'playstation', aliases: ['psp', 'playstation portable'] },
  { title: 'PS Vita', handle: 'ps-vita', family: 'playstation', aliases: ['ps vita', 'vita', 'playstation vita'] },
  { title: 'Xbox', handle: 'xbox', family: 'xbox', aliases: ['xbox', 'microsoft'] },
  { title: 'Original Xbox', handle: 'original-xbox', family: 'xbox', aliases: ['original xbox', 'og xbox'] },
  { title: 'Xbox 360', handle: 'xbox-360', family: 'xbox', aliases: ['xbox 360', '360'] },
  { title: 'Xbox One', handle: 'xbox-one', family: 'xbox', aliases: ['xbox one'] },
  { title: 'Xbox Series X', handle: 'xbox-series-x', family: 'xbox', aliases: ['xbox series x', 'series x'] }
];

const rpgSearchDistance = (first, second) => {
  const rows = Array.from({ length: first.length + 1 }, (_, index) => [index]);
  for (let column = 0; column <= second.length; column += 1) rows[0][column] = column;
  for (let row = 1; row <= first.length; row += 1) {
    for (let column = 1; column <= second.length; column += 1) {
      rows[row][column] = Math.min(
        rows[row - 1][column] + 1,
        rows[row][column - 1] + 1,
        rows[row - 1][column - 1] + (first[row - 1] === second[column - 1] ? 0 : 1)
      );
    }
  }
  return rows[first.length][second.length];
};

// Reveal RPG artwork only after its pixels are ready. This is shared by the
// catalog, product page, and dynamically-rendered search results so cached and
// network-loaded images use the same gentle entrance instead of popping in.
window.RpgRevealImages = window.RpgRevealImages || ((scope = document) => {
  const selector = '.rpg-game-card__artwork-clip img, .rpg-search-game__image, .rpg-home__system-slide img';
  const images = [];
  if (scope.matches?.(selector)) images.push(scope);
  scope.querySelectorAll?.(selector).forEach((image) => images.push(image));

  images.forEach((image) => {
    if (image.classList.contains('rpg-image-ready')) return;
    const frame = image.closest('.rpg-game-card__artwork-shell, .rpg-search-game__frame, .rpg-home__system-slide');
    frame?.classList.add('rpg-artwork-loading');
    frame?.setAttribute('aria-busy', 'true');

    const reveal = () => requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        image.classList.add('rpg-image-ready');
        frame?.classList.remove('rpg-artwork-error');
        frame?.classList.add('rpg-artwork-ready');
        frame?.removeAttribute('aria-busy');
        window.setTimeout(() => frame?.classList.remove('rpg-artwork-loading'), 380);
      });
    });

    const showFallback = () => {
      const fallbackSource = image.dataset.rpgFallbackSrc;
      if (fallbackSource && image.src !== fallbackSource && image.dataset.rpgFallbackTried !== 'true') {
        image.dataset.rpgFallbackTried = 'true';
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.src = fallbackSource;
      }
      // If neither source loads, retain the reserved loading frame. A broken
      // image or error message is more disruptive than an honest loading state.
    };

    if (image.complete) {
      if (image.naturalWidth) reveal();
      else showFallback();
      return;
    }

    image.addEventListener('load', reveal, { once: true });
    image.addEventListener('error', showFallback, { once: true });
  });
});

const initializeRpgImageReveal = () => {
  window.RpgRevealImages(document);
  if (window.RpgImageRevealObserver) return;
  window.RpgImageRevealObserver = new MutationObserver((records) => {
    records.forEach((record) => record.addedNodes.forEach((node) => {
      if (node.nodeType === Node.ELEMENT_NODE) window.RpgRevealImages(node);
    }));
  });
  window.RpgImageRevealObserver.observe(document.documentElement, { childList: true, subtree: true });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeRpgImageReveal, { once: true });
} else {
  initializeRpgImageReveal();
}

if (!customElements.get('predictive-search')) {
  class PredictiveSearch extends HTMLElement {
    constructor() {
      super();
      this.cachedResults = {};
      this.input = this.querySelector('.js-search-input');
      this.productTypeSelect = this.querySelector('.js-search-product-types');
      this.productTypeInput = document.getElementById('product_type_input');
      this.resetBtn = this.querySelector('.js-search-reset');
      this.results = this.querySelector('.js-search-results');
      this.overlay = this.querySelector('.js-search-overlay');
      this.statusEl = this.querySelector('.js-search-status');
      this.loadingText = this.getAttribute('data-loading-text');
      this.searchRequestId = 0;
      this.rpgAliasRequestId = 0;
      this.searchAbortController = null;
      this.addListeners();
    }

    /**
     * Triggers when the web component is removed from the DOM
     */
    disconnectedCallback() {
      this.close();
    }

    addListeners() {
      this.input.addEventListener('focus', this.handleFocus.bind(this));
      this.input.addEventListener('input', debounce(this.handleInput.bind(this), 180));
      if (this.productTypeSelect) {
        this.productTypeSelect.addEventListener('change', this.handleProductTypeChange.bind(this));
      }
      this.querySelector('.search').addEventListener('submit', this.handleSubmit.bind(this));
    }

    /**
     * Gets the value of the search input field.
     * @returns {string}
     */
    getQuery() {
      return this.input.value.trim();
    }

    /**
     * Handles search form submit.
     * @param {object} evt - Event object.
     */
    handleSubmit(evt) {
      if (this.hasAttribute('data-rpg-unified-search')) {
        evt.preventDefault();
        const firstResult = this.querySelector('.predictive-search__item:not(.js-submit) .js-search-link');
        if (firstResult) {
          firstResult.click();
          return;
        }

        const query = this.getQuery();
        if (query) {
          const destination = new URL(window.Shopify?.routes?.root || '/', window.location.origin);
          destination.searchParams.set('rpg-search', query);
          window.location.assign(destination.toString());
        }
        return;
      }

      if (
        !this.getQuery().length
        || this.querySelector('.predictive-search__item[aria-selected="true"]:not(.js-submit)')
      ) {
        evt.preventDefault();
      }
    }

    /**
     * Handles 'input' events on the search field.
     */
    handleInput() {
      // autocomplete=off prevents browser from restoring value after using back button in Safari
      this.input.setAttribute('value', this.input.value);

      const searchTerm = this.getQuery();

      if (!searchTerm.length) {
        this.close();
        return;
      }

      this.getResults(searchTerm);
    }

    /**
     * Handles a change of product type
     * @param {object} evt - Event object.
     */
    handleProductTypeChange(evt) {
      this.productTypeInput.value = evt.detail.selectedValue;
      const query = this.getQuery();
      if (query.length > 0) {
        this.getResults(query);
      }
    }

    /**
     * Handles 'focus' events on the search field.
     */
    handleFocus() {
      const searchTerm = this.getQuery();
      if (!searchTerm.length) return;

      if (this.getAttribute('results') === 'true') {
        this.open();
      } else {
        this.getResults(searchTerm);
      }
    }

    /**
     * Handles 'keydown' events on the custom element.
     * @param {object} evt - Event object.
     */
    handleKeydown(evt) {
      // Let tabs script handle keydown events on the tab buttons.
      if (evt.target.matches('.tablist__tab')) return;

      switch (evt.key) {
        case 'ArrowUp':
        case 'ArrowDown':
          evt.preventDefault();

          if (this.hasAttribute('open')) {
            this.handleResultsNav(evt.key);
          }
          break;

        case 'Enter':
          this.selectOption();
          break;

        case 'Escape':
          this.close();
          break;

        // no default
      }
    }

    /**
     * Handles 'keyup' events on the custom element.
     */
    handleKeyup() {
      // If search field is empty after key press, close the results.
      if (!this.getQuery().length) this.close();
    }

    /**
     * Handles keyboard navigation of the results.
     * @param {string} key - Key pressed.
     */
    handleResultsNav(key) {
      const selectedResult = this.querySelector(
        '[role="tabpanel"]:not([hidden]) [aria-selected="true"]'
      );
      const allResults = this.querySelectorAll(
        '[role="tabpanel"]:not([hidden]) .predictive-search__item'
      );
      let resultToSelect = allResults[0];

      if (key === 'ArrowUp') {
        if (!selectedResult) return;

        // Select the next result up or the last one if we've reached the top of the list.
        resultToSelect = selectedResult.previousElementSibling || allResults[allResults.length - 1];
      } else if (key === 'ArrowDown') {
        if (selectedResult) {
          // Select the next result down or the first one if we've reached the bottom of the list.
          resultToSelect = selectedResult.nextElementSibling || allResults[0];
        }
      }

      this.statusEl.textContent = '';

      if (resultToSelect) {
        // If the selected item didn't change, do nothing.
        if (resultToSelect === selectedResult) return;

        resultToSelect.setAttribute('aria-selected', 'true');
        if (selectedResult) selectedResult.setAttribute('aria-selected', 'false');

        this.setLiveRegionText(resultToSelect.textContent);
        this.input.setAttribute('aria-activedescendant', resultToSelect.id);
      }
    }

    /**
     * Selects a result
     */
    selectOption() {
      const selectedResult = this.querySelector('[aria-selected="true"] > .js-search-link');
      if (selectedResult) selectedResult.click();
    }

    /**
     * Gets the results for a search term.
     * @param {string} searchTerm - Search query.
     */
    async getResults(searchTerm) {
      const requestId = ++this.searchRequestId;
      this.searchAbortController?.abort();
      this.searchAbortController = new AbortController();
      this.showRpgLoadingState('Searching inventory…');
      this.setLiveRegionLoadingState();

      let searchFields = 'title,product_type,variants.title,vendor';
      if (theme.settings.pSearchIncludeSkus) searchFields += ',variants.sku';
      if (theme.settings.pSearchIncludeTags) searchFields += ',tag';

      let searchParams = '';
      if (this.productTypeInput && this.productTypeInput.value !== '') {
        searchParams = `q=product_type:${encodeURIComponent(this.productTypeInput.value)} AND ${encodeURIComponent(searchTerm)}`;
      } else {
        searchParams = `q=${encodeURIComponent(searchTerm)}`;
      }

      searchParams += `&${encodeURIComponent('resources[limit]')}=${theme.settings.pSearchLimit}`;
      searchParams += `&${encodeURIComponent('resources[limit_scope]')}=${
        theme.settings.pSearchLimitScope
      }`;
      searchParams += `&${encodeURIComponent('resources[options][fields]')}=${searchFields}`;
      searchParams += '&section_id=predictive-search';

      const queryKey = searchParams.replace(' ', '-').toLowerCase();
      if (this.cachedResults[queryKey]) {
        if (requestId === this.searchRequestId && searchTerm === this.getQuery()) {
          this.renderResults(this.cachedResults[queryKey]);
        }
        return;
      }

      try {
        const response = await fetch(`${theme.routes.predictiveSearch}?${searchParams}`, {
          signal: this.searchAbortController.signal,
        });
        if (!response.ok) throw new Error(response.status);

        const tmpl = document.createElement('template');
        tmpl.innerHTML = await response.text();

        if (requestId !== this.searchRequestId || searchTerm !== this.getQuery()) return;

        const resultsEl = tmpl.content.querySelector('#shopify-section-predictive-search');
        if (!resultsEl) return;
        const resultsMarkup = resultsEl.innerHTML.replace(/psearch/g, this.input.id);

        this.cachedResults[queryKey] = resultsMarkup;
        this.renderResults(resultsMarkup);
      } catch (error) {
        if (error.name === 'AbortError') return;
        this.close();
        throw error;
      }
    }

    /**
     * Sets the live region loading state.
     */
    setLiveRegionLoadingState() {
      this.setLiveRegionText(this.loadingText);
    }

    /**
     * Sets the live region text.
     * @param {string} statusText - Status text.
     */
    setLiveRegionText(statusText) {
      this.statusEl.setAttribute('aria-hidden', 'false');
      this.statusEl.textContent = statusText;

      setTimeout(() => {
        this.statusEl.setAttribute('aria-hidden', 'true');
      }, 1000);
    }

    /**
     * Renders the results markup.
     * @param {string} resultsMarkup - Results markup.
     */
    renderResults(resultsMarkup) {
      this.results.innerHTML = resultsMarkup;
      this.renderRpgSystemResults();
      this.updateRpgEmptyState(true);
      void this.renderRpgAliasResults();
      window.RpgRevealImages?.(this.results);
      this.setAttribute('results', true);
      this.open();
      this.setupScrollState();
    }

    ensureRpgLoadingIndicator(resultsContainer, message) {
      let loader = resultsContainer.querySelector('.rpg-search-loading');
      if (!loader) {
        loader = document.createElement('div');
        loader.className = 'rpg-search-loading';
        loader.innerHTML = `
          <span class="rpg-search-loading__pixels" aria-hidden="true">
            <i></i><i></i><i></i>
          </span>
          <strong></strong>`;
        resultsContainer.prepend(loader);
      }
      loader.querySelector('strong').textContent = message;
      return loader;
    }

    showRpgLoadingState(message) {
      let resultsContainer = this.results.querySelector('.rpg-search-results');
      if (!resultsContainer) {
        this.results.innerHTML = `
          <div class="predictive-search predictive-search--rpg absolute bg-theme-bg text-theme-text text-start">
            <div class="predictive-search__scroller overflow-auto">
              <div class="predictive-search__results rpg-search-results"></div>
            </div>
          </div>`;
        resultsContainer = this.results.querySelector('.rpg-search-results');
      }
      this.ensureRpgLoadingIndicator(resultsContainer, message);
      this.open();
    }

    updateRpgEmptyState(aliasSearchPending = false) {
      const resultsContainer = this.results.querySelector('.rpg-search-results');
      if (!resultsContainer) return;

      const hasResults = Boolean(resultsContainer.querySelector(
        '.rpg-search-group .predictive-search__item:not(.js-submit)'
      ));
      let emptyState = resultsContainer.querySelector('.predictive-search__no-results');
      const loader = resultsContainer.querySelector('.rpg-search-loading');

      if (hasResults) {
        loader?.remove();
        emptyState?.remove();
        return;
      }

      if (!emptyState) {
        emptyState = document.createElement('div');
        emptyState.className = 'predictive-search__no-results';
        emptyState.textContent = 'No matching games or systems yet.';
        resultsContainer.append(emptyState);
      }
      if (aliasSearchPending) {
        emptyState.hidden = true;
        this.ensureRpgLoadingIndicator(resultsContainer, 'Checking the game library…');
      } else {
        loader?.remove();
        emptyState.hidden = false;
      }
    }

    renderRpgSystemResults() {
      const query = this.input.value.trim().toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
      const resultsContainer = this.results.querySelector('.rpg-search-results');
      if (!resultsContainer || !query) return;

      this.results.querySelector('#RpgSearchSystems')?.closest('.rpg-search-group')?.remove();
      this.rpgMatchedSystemTitles = [];

      const familyNames = ['nintendo', 'playstation', 'xbox'];
      const matchedFamily = familyNames.find((family) => (
        query === family || rpgSearchDistance(query, family) <= (family.length > 6 ? 2 : 1)
      ));
      let matches;
      if (matchedFamily) {
        matches = rpgSearchSystems.filter((system) => system.family === matchedFamily);
      } else {
        const exactMatches = rpgSearchSystems.filter((system) => system.aliases.includes(query));
        const partialMatches = rpgSearchSystems.filter((system) => (
          system.aliases.some((alias) => alias.includes(query))
        ));
        matches = [...new Set([...exactMatches, ...partialMatches])];
        if (!matches.length) {
          matches = rpgSearchSystems.filter((system) => system.aliases.some((alias) => {
            if (query.length <= 3 || alias.length <= 3) return false;
            const tolerance = Math.min(2, Math.max(1, Math.floor(alias.length / 6)));
            return rpgSearchDistance(query, alias) <= tolerance;
          }));
        }
      }
      if (!matches.length) return;
      this.rpgMatchedSystemTitles = matches.map((system) => system.title.toLowerCase());

      const section = document.createElement('section');
      section.className = 'rpg-search-group';
      section.setAttribute('aria-labelledby', 'RpgSearchSystems');
      section.innerHTML = `
        <h2 class="rpg-search-group__title" id="RpgSearchSystems">System pages</h2>
        <ul class="rpg-search-systems" role="list">
          ${matches.map((system) => `
            <li class="predictive-search__item" role="option">
              <a class="rpg-search-system rpg-search-system--${system.handle} rpg-console-color rpg-console-color--${system.handle} js-search-link focus-inset" href="/collections/${system.handle}">
                <span class="rpg-search-system__mark" aria-hidden="true">→</span>
                <strong>${system.title}</strong>
              </a>
            </li>
          `).join('')}
        </ul>`;
      resultsContainer.prepend(section);
    }

    async renderRpgAliasResults() {
      const query = this.input.value.trim().toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
      const aliasRequestId = ++this.rpgAliasRequestId;
      if (!query) {
        this.updateRpgEmptyState(false);
        return;
      }

      if (!window.RpgGameSearchIndex) {
        const root = window.Shopify?.routes?.root || '/';
        window.RpgGameSearchIndex = Promise.all(Array.from({ length: 6 }, (_, index) => (
          fetch(`${root}collections/all?view=games&page=${index + 1}`)
            .then((response) => response.ok ? response.text() : '')
        )))
          .then((pages) => {
            const gamesByUrl = new Map();
            pages.forEach((markup) => {
              const documentCopy = new DOMParser().parseFromString(markup, 'text/html');
              documentCopy.querySelectorAll('.rpg-game-card').forEach((card) => {
                const game = {
                  search: card.dataset.rpgSearch || card.dataset.rpgTitle || '',
                  title: card.querySelector('.rpg-game-card__title a')?.textContent.trim() || '',
                  url: card.querySelector('.rpg-game-card__title a')?.href || '',
                  image: card.querySelector('.rpg-game-card__artwork-clip img')?.src || '',
                  platform: card.dataset.rpgPlatform || '',
                  platformLabel: card.querySelector('.rpg-game-card__platform-art-strip-text')?.textContent.trim() || '',
                  release: card.querySelector('.rpg-game-card__release-text')?.textContent.trim() || '',
                  badges: Array.from(card.querySelectorAll('.rpg-game-card__meta .rpg-game-card__badge')).map((badge) => ({
                    text: badge.textContent.trim(),
                    type: badge.dataset.rpgBadgeInfo || '',
                  })),
                  price: card.querySelector('.rpg-game-card__price')?.textContent.replace(/\s+/g, '') || '',
                  other: card.querySelector('.rpg-game-card__other-price')?.textContent.replace(/\s+/g, ' ').trim() || '',
                };
                if (game.title && game.url && !gamesByUrl.has(game.url)) gamesByUrl.set(game.url, game);
              });
            });
            return Array.from(gamesByUrl.values());
          })
          .catch(() => []);
      }

      const games = await window.RpgGameSearchIndex;
      if (
        aliasRequestId !== this.rpgAliasRequestId
        || query !== this.input.value.trim().toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim()
      ) return;

      const matchingPlatforms = this.rpgMatchedSystemTitles || [];
      const isConsoleSearch = matchingPlatforms.length > 0;
      const scoreGame = (game) => {
        const normalized = game.search.replace(/[^a-z0-9]+/g, ' ').trim();
        if (normalized === query) return 0;
        const words = normalized.split(' ');
        if (words.includes(query)) return 1;
        const titleWords = game.title.toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim().split(' ').filter(Boolean);
        const titleAcronym = titleWords.map((word) => word[0]).join('');
        if (query.length >= 2 && titleAcronym.startsWith(query)) return 1;
        if (normalized.includes(query)) return 2;
        const tolerance = query.length >= 7 ? 2 : query.length >= 4 ? 1 : 0;
        if (tolerance && words.some((word) => rpgSearchDistance(query, word) <= tolerance)) return 3;
        return matchingPlatforms.includes(game.platform.toLowerCase()) ? 10 : 99;
      };
      const existingUrls = new Set(Array.from(this.results.querySelectorAll('.rpg-search-game')).map((link) => link.href));
      let matches = games
        .map((game) => ({ ...game, score: scoreGame(game) }))
        .filter((game) => game.score < 99 && !existingUrls.has(game.url))
        .sort((first, second) => first.score - second.score || first.title.localeCompare(second.title));
      if (isConsoleSearch) matches = matches.slice(0, 20);
      if (!matches.length) {
        this.updateRpgEmptyState(false);
        return;
      }

      const resultsContainer = this.results.querySelector('.rpg-search-results');
      if (!resultsContainer) return;
      let section = this.results.querySelector('#RpgSearchGames')?.closest('.rpg-search-group');
      let list = section?.querySelector('.rpg-search-games');
      if (!section || !list) {
        section = document.createElement('section');
        section.className = 'rpg-search-group rpg-search-group--aliases';
        section.setAttribute('aria-labelledby', 'RpgSearchAliases');
        const heading = document.createElement('h2');
        heading.className = 'rpg-search-group__title';
        heading.id = 'RpgSearchAliases';
        heading.textContent = 'Games';
        list = document.createElement('ul');
        list.className = 'rpg-search-games';
        list.setAttribute('role', 'list');
        section.append(heading, list);
        resultsContainer.append(section);
      }
      matches.forEach((game) => {
        const item = document.createElement('li');
        item.className = 'predictive-search__item';
        item.setAttribute('role', 'option');
        const link = document.createElement('a');
        link.className = 'rpg-search-game js-search-link focus-inset';
        link.href = game.url;
        if (game.image) {
          const media = document.createElement('span');
          media.className = 'rpg-search-game__media rpg-game-card__media';
          const frame = document.createElement('span');
          const platformHandle = game.platform.replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
          const releaseHandle = (game.release || '').replace(/[^a-z0-9]+/gi, '-').replace(/^-|-$/g, '').toLowerCase();
          frame.className = `rpg-search-game__frame rpg-game-card__artwork-shell rpg-game-card__artwork-shell--${platformHandle} rpg-console-color rpg-console-color--${platformHandle}${releaseHandle ? ` rpg-search-game__frame--${releaseHandle} rpg-game-card__artwork-shell--release-${releaseHandle}` : ''}`;
          frame.style.width = '70.5882%';
          frame.style.height = '100%';
          const clip = document.createElement('span');
          clip.className = 'rpg-search-game__clip rpg-game-card__artwork-clip';
          const image = document.createElement('img');
          image.className = 'rpg-search-game__image';
          image.src = game.image;
          image.alt = '';
          clip.append(image);
          const platformStrip = document.createElement('span');
          platformStrip.className = 'rpg-game-card__platform-art-strip';
          platformStrip.setAttribute('aria-hidden', 'true');
          const platformText = document.createElement('span');
          const platformLabel = game.platformLabel || game.platform;
          const platformScale = platformLabel.length <= 5 ? 'short' : platformLabel.length >= 18 ? 'extra-long' : platformLabel.length >= 13 ? 'long' : 'medium';
          platformText.className = `rpg-game-card__platform-art-strip-text rpg-game-card__platform-art-strip-text--${platformScale}`;
          platformText.textContent = platformLabel;
          platformStrip.append(platformText);
          clip.append(platformStrip);
          frame.append(clip);
          if (game.release) {
            const fold = document.createElement('span');
            fold.className = `rpg-game-card__release-fold rpg-game-card__release-fold--${releaseHandle}`;
            fold.setAttribute('aria-hidden', 'true');
            const release = document.createElement('span');
            release.className = `rpg-game-card__release rpg-game-card__release--${releaseHandle}`;
            const releaseText = document.createElement('span');
            releaseText.className = 'rpg-game-card__release-text';
            releaseText.textContent = game.release;
            release.append(releaseText);
            frame.append(fold, release);
          }
          media.append(frame);
          link.append(media);
        }
        const info = document.createElement('span');
        info.className = 'rpg-search-game__info';
        const title = document.createElement('strong');
        title.className = 'rpg-search-game__title';
        title.textContent = game.title;
        info.append(title);
        const badges = document.createElement('span');
        badges.className = 'rpg-search-game__badges';
        game.badges.forEach((gameBadge) => {
          const badge = document.createElement('span');
          let badgeType = gameBadge.type;
          if (badgeType === 'multiple-options') badgeType = 'options';
          if (badgeType === 'complete' || badgeType === 'game-box') badgeType = `included-${badgeType}`;
          if (badgeType === 'disc-only' || badgeType === 'cart-only') badgeType = 'included-game-only';
          badge.className = `rpg-search-badge rpg-search-badge--${badgeType}`;
          badge.textContent = gameBadge.text;
          badges.append(badge);
        });
        info.append(badges);
        if (game.price) {
          const price = document.createElement('span');
          price.className = 'rpg-search-game__price';
          price.textContent = game.price;
          info.append(price);
        }
        if (game.other) {
          const other = document.createElement('span');
          other.className = 'rpg-search-game__other';
          other.textContent = game.other;
          info.append(other);
        }
        link.append(info);
        const action = document.createElement('span');
        action.className = 'rpg-search-game__action rpg-game-card__action';
        action.textContent = 'View Game';
        link.append(action);
        item.append(link);
        list.append(item);
      });
      const allGameItems = Array.from(list.querySelectorAll('.predictive-search__item:not(.js-submit)'));
      if (isConsoleSearch) allGameItems.slice(20).forEach((item) => item.remove());
      list.querySelector('.rpg-search-all')?.remove();
      if (isConsoleSearch && (allGameItems.length >= 20 || matches.length >= 20)) {
        const searchAllItem = document.createElement('li');
        searchAllItem.className = 'predictive-search__item js-submit rpg-search-all';
        const searchAllLink = document.createElement('a');
        searchAllLink.className = 'predictive-search__view-all js-search-link focus-inset';
        const destination = new URL(window.Shopify?.routes?.root || '/', window.location.origin);
        destination.searchParams.set('rpg-search', this.input.value.trim());
        searchAllLink.href = destination.toString();
        searchAllLink.textContent = 'Search all';
        searchAllItem.append(searchAllLink);
        list.append(searchAllItem);
      }
      window.RpgRevealImages?.(section);
      this.updateRpgEmptyState(false);
      this.setupScrollState();
    }

    setupScrollState() {
      const scroller = this.querySelector('.predictive-search__scroller');
      if (!scroller) {
        this.classList.remove('rpg-search-has-more', 'rpg-search-has-above');
        return;
      }

      let frame;
      const update = () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          const hasMoreBelow = scroller.scrollTop + scroller.clientHeight < scroller.scrollHeight - 2;
          this.classList.toggle('rpg-search-has-more', hasMoreBelow);
          this.classList.toggle('rpg-search-has-above', scroller.scrollTop > 2);
        });
      };

      if (!scroller.dataset.rpgScrollStateBound) {
        scroller.dataset.rpgScrollStateBound = 'true';
        scroller.addEventListener('scroll', update, { passive: true });
        scroller.addEventListener('touchmove', () => {
          if (window.matchMedia('(max-width: 768.98px)').matches) this.input.blur();
        }, { passive: true });
        new ResizeObserver(update).observe(scroller);
      }
      update();
    }

    /**
     * Opens the results listbox.
     */
    open() {
      this.overlay.classList.add('is-visible');
      if (this.getQuery().length) this.resetBtn.hidden = false;
      this.input.setAttribute('aria-expanded', 'true');
      this.setAttribute('open', '');
      document.body.classList.add('overlay-predictive-search');
      this.setupScrollState();

      // Add event handlers (so the bound event listeners can be removed).
      this.keydownHandler = this.keydownHandler || this.handleKeydown.bind(this);
      this.keyupHandler = this.keyupHandler || this.handleKeyup.bind(this);
      this.resetBtnClickHandler = this.resetBtnClickHandler || this.close.bind(this);
      this.overlayClickHandler = this.overlayClickHandler || this.close.bind(this);

      // Add event listeners (for while results are open).
      this.addEventListener('keydown', this.keydownHandler);
      this.addEventListener('keyup', this.keyupHandler);
      this.resetBtn.addEventListener('click', this.resetBtnClickHandler);
      this.overlay.addEventListener('click', this.overlayClickHandler);
    }

    /**
     * Closes the results listbox.
     * @param {object} evt - Event object.
     */
    close(evt) {
      // If reset button was clicked, empty the input field.
      if (evt && evt.target === this.resetBtn) {
        this.input.value = '';
        this.removeAttribute('results');
        this.input.focus();
      }

      // Deselect the selected result (if there is one).
      const selected = this.querySelector('.predictive-search__item[aria-selected="true"]');
      if (selected) selected.setAttribute('aria-selected', 'false');

      this.removeAttribute('open');
      this.resetBtn.hidden = true;
      this.overlay.classList.remove('is-visible');
      this.input.setAttribute('aria-activedescendant', '');
      this.input.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('overlay-predictive-search');
      this.classList.remove('rpg-search-has-more', 'rpg-search-has-above');

      // Remove event listeners added on search results opening.
      this.removeEventListener('keydown', this.keydownHandler);
      this.resetBtn.removeEventListener('click', this.resetBtnClickHandler);
      this.overlay.removeEventListener('click', this.overlayClickHandler);
    }
  }

  customElements.define('predictive-search', PredictiveSearch);
}

})();
